import React from "react";
import { useQuery } from "@tanstack/react-query";
import { productService } from "../../services/product";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column"; 

import { Toolbar } from "primereact/toolbar";

export default function WarehouseProducts() {
   

  const { data: products, isLoading } = useQuery({
    queryKey: ["warehouseProducts"],
    queryFn: () =>
      productService.getWarehouseProducts().then((res) => res.data), 
  });

  const partiBodyTemplate = (rowData) => { 
    return (<div>{rowData.belgeNo} / {rowData.parti}</div>);
  };
 
  const cols = [
    { field: "tarihFormatted", header: "Tarih" },
    { field: "urun", header: "Ürün" },
    { field: "belgeNo", header: "Parti No" ,body:partiBodyTemplate }, 
    { field: "kg", header: "Kg" },
    { field: "mt", header: "Mt"  },
  ];

  
  const startContent = (
    <div className="text-2xl font-bold">Depodaki Ürünler</div>
  );

  

 
  const footer = `Ürün Sayısı : ${products ? products.length : 0}`;

  return (
    <div >
   
        <Toolbar className="shadow-3 border-round-md my-2"
          start={startContent}   />
      
   
        <DataTable   loading={isLoading}
          emptyMessage="Liste Boş"  scrollable scrollHeight="flex"
          footer={footer}  className="shadow-3 border-round-md table-content surface-ground "
          value={products || []}
          tableStyle={{ minWidth: "50rem" }}
        >
          {cols.map((col, i) => (
            <Column key={i} field={col.field} header={col.header}  body={col.body} />
          ))}
        
        </DataTable>
      
    </div>
  );
}
